const OFFER_NOTIFICATION='OfertaDeTrabajoNotificacion/';

export class OfferNotification{
    public static readonly OFFER_LIST = `${OFFER_NOTIFICATION}offer-list/{estado}`;
}